import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/verified.png';
const _hoisted_1 = { class: "simplePage" };
const _hoisted_2 = { class: "anchor-bottom" };
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PolicySuccessPage',
    setup(__props) {
        useAuth();
        const route = useRoute();
        const router = useRouter();
        const type = computed(() => route.query.type);
        const section = computed(() => {
            if (route.query.type === 'pension' || route.query.type === 'mortgage') {
                return 'lt';
            }
            else if (route.query.type === 'policy') {
                return 'ins';
            }
            else if (route.query.type === 'account') {
                return 'd2d';
            }
            return 'd2d';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0",
                    bgcolor: "transparent"
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("img", {
                        class: "heroImg",
                        src: _imports_0
                    }, null, -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Success!", -1)),
                    _createElementVNode("p", null, "You have successfully added your " + _toDisplayString(type.value) + ".", 1),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(MGButton, {
                            text: "Done",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/money'))),
                            arrow: false
                        })
                    ])
                ])
            ], 64));
        };
    }
});
